/* import __COLOCATED_TEMPLATE__ from './private-message-glyph.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./private-message-glyph.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: null,
  href: null,
  title: null,
  ariaLabel: null,
  shouldShow: null
}));